import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PATHS } from '../../../config/consts';
import {
  buildUrlWithQueryParams,
  clearQueryStringOnCurrentUrl,
  UrlQueryParamName,
  UrlQueryParamValueBoolean,
} from '../../../helpers/queryParams';
import { TYPE_DESCRIPTOR } from '../../../modules/notifications';
import { addSnackbarError } from '../../../modules/notifications/actions';
import messages from '../messages';

interface IUseLoginQueryParams {
  isSSOLogin: boolean;
}

const useLoginQueryParams = (): IUseLoginQueryParams => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSSOLogin = searchParams.get(UrlQueryParamName.OrySSOLoginFinished) === UrlQueryParamValueBoolean.True;
  const oryFlowId = searchParams.get(UrlQueryParamName.OryFlow);
  const isOrganizationUserAlreadyExists =
    searchParams.get(UrlQueryParamName.OryOrganizationUserAlreadyExists) === UrlQueryParamValueBoolean.True;

  const errorMessageShowed = useRef(false);

  if (oryFlowId && isOrganizationUserAlreadyExists && !errorMessageShowed.current) {
    errorMessageShowed.current = true;
    clearQueryStringOnCurrentUrl();
    const logoutUrl = buildUrlWithQueryParams({
      baseUrl: PATHS.LOGOUT,
      queryParams: { [UrlQueryParamName.IsOrySessionActive]: UrlQueryParamValueBoolean.True },
    });
    navigate(logoutUrl);
    dispatch(addSnackbarError(messages.ImsLoginErrorSSOMigration, TYPE_DESCRIPTOR));
  }

  return {
    isSSOLogin,
  };
};

export default useLoginQueryParams;
